/// <amd-module name="Repos/PullRequestActions/RestClient/Graph" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\pr-details-actions\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as VS_Graph from "VSS/Platform/Contracts/Graph";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IGraphRestClient extends IVssRestClient {
    /**
     * Create a new Azure DevOps group or materialize an existing AAD group.
     * 
     * @param creationContext - The subset of the full graph group used to uniquely find the graph subject in an external provider.
     * @param scopeDescriptor - A descriptor referencing the scope (collection, project) in which the group should be created. If omitted, will be created in the scope of the enclosing account or organization. Valid only for VSTS groups.
     * @param groupDescriptors - A comma separated list of descriptors referencing groups you want the graph group to join
     */
    createGroup(creationContext: VS_Graph.GraphGroupCreationContext, scopeDescriptor?: string, groupDescriptors?: VS_Services.SubjectDescriptor[]): Promise<VS_Graph.GraphGroup>;
    /**
     * Resolve a descriptor to a storage key.
     * 
     * @param subjectDescriptor - 
     */
    getStorageKey(subjectDescriptor: string): Promise<VS_Graph.GraphStorageKeyResult>;
    /**
     * Materialize an existing AAD or MSA user into the ADO account.
     * 
     * @param creationContext - The subset of the full graph user used to uniquely find the graph subject in an external provider.
     * @param groupDescriptors - A comma separated list of descriptors of groups you want the graph user to join
     */
    createUser(creationContext: VS_Graph.GraphUserCreationContext, groupDescriptors?: VS_Services.SubjectDescriptor[]): Promise<VS_Graph.GraphUser>;
}

class GraphRestClient extends RestClientBase implements IGraphRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a new Azure DevOps group or materialize an existing AAD group.
     * 
     * @param creationContext - The subset of the full graph group used to uniquely find the graph subject in an external provider.
     * @param scopeDescriptor - A descriptor referencing the scope (collection, project) in which the group should be created. If omitted, will be created in the scope of the enclosing account or organization. Valid only for VSTS groups.
     * @param groupDescriptors - A comma separated list of descriptors referencing groups you want the graph group to join
     */
    public async createGroup(
        creationContext: VS_Graph.GraphGroupCreationContext,
        scopeDescriptor?: string,
        groupDescriptors?: VS_Services.SubjectDescriptor[]
        ): Promise<VS_Graph.GraphGroup> {

        const queryValues: any = {
            scopeDescriptor: scopeDescriptor,
            groupDescriptors: groupDescriptors && groupDescriptors.join(",")
        };

        return this.beginRequest<VS_Graph.GraphGroup>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/Groups/{groupDescriptor}",
            queryParams: queryValues,
            body: creationContext
        });
    }

    /**
     * Resolve a descriptor to a storage key.
     * 
     * @param subjectDescriptor - 
     */
    public async getStorageKey(
        subjectDescriptor: string
        ): Promise<VS_Graph.GraphStorageKeyResult> {

        return this.beginRequest<VS_Graph.GraphStorageKeyResult>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Graph/StorageKeys/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            }
        });
    }

    /**
     * Materialize an existing AAD or MSA user into the ADO account.
     * 
     * @param creationContext - The subset of the full graph user used to uniquely find the graph subject in an external provider.
     * @param groupDescriptors - A comma separated list of descriptors of groups you want the graph user to join
     */
    public async createUser(
        creationContext: VS_Graph.GraphUserCreationContext,
        groupDescriptors?: VS_Services.SubjectDescriptor[]
        ): Promise<VS_Graph.GraphUser> {

        const queryValues: any = {
            groupDescriptors: groupDescriptors && groupDescriptors.join(",")
        };

        return this.beginRequest<VS_Graph.GraphUser>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Graph/Users/{userDescriptor}",
            queryParams: queryValues,
            body: creationContext
        });
    }

}

export const GraphClientName = "Repos.PRActions.Graph.IGraphRestClient";

export function getGraphClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGraphRestClient {
    return pageContext.getRestClient<IGraphRestClient>(GraphClientName, options);
}

RestClients.add(GraphClientName, { 
    factory: GraphRestClient,
    options: {
        resourceAreaId: "bb1e7ec9-e901-4b68-999a-de7012b920f8",
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
